// 本月大瓜 —— 站点展示数据
// 说明：热搜榜、网友热议与群众反应均以“话题聚合 / 网友观点”方式呈现，用于展示讨论氛围，不指向真实人物与机构。

export const siteInfo = {
  brand: "本月大瓜",
  slogan: "全网热点 · 一网吃尽",
  sub: "搜罗本月最热的大瓜围观现场，聚合网友热议评论与群众反应，和你一起追更讨论。",
  edition: "2026年9月 第 9 期",
  hotComments: "1,284,600",
  liveViewers: "3.2万",
};

export const heroHighlights = [
  { label: "本期热点专题", value: "6 大板块" },
  { label: "今日新增热议", value: "428 条" },
  { label: "围观人数", value: "23.6 万" },
];

export type HotItem = {
  id: number;
  title: string;
  tag: string;
  heat: string;
  comments: string;
  delta: "up" | "down" | "new";
};

export const hotList: HotItem[] = [
  { id: 1, title: "都市剧《夜色下的咖啡》大结局，结局走向吵上热搜", tag: "影视", heat: "986 万", comments: "18.4 万", delta: "up" },
  { id: 2, title: "人气乐队「青柠公路」新专风格大改，歌迷评论区两派互呛", tag: "音乐", heat: "742 万", comments: "12.1 万", delta: "up" },
  { id: 3, title: "年度游戏《山海奇谭》资料片开服，玩家熬夜排队刷副本", tag: "游戏", heat: "615 万", comments: "9.8 万", delta: "new" },
  { id: 4, title: "萌宠博主「阿橘」停更一个月后回归，评论区集体泪目", tag: "生活", heat: "520 万", comments: "8.2 万", delta: "up" },
  { id: 5, title: "综艺回锅季导师阵容官宣，谁真唱谁坐镇吵得不可开交", tag: "综艺", heat: "438 万", comments: "6.9 万", delta: "down" },
  { id: 6, title: "老牌综艺停播传闻发酵，节目组连夜下场发声明", tag: "综艺", heat: "366 万", comments: "5.4 万", delta: "up" },
  { id: 7, title: "独立电影《候鸟不归》上映口碑两极，网友吵出三大阵营", tag: "影视", heat: "301 万", comments: "4.3 万", delta: "new" },
  { id: 8, title: "顶流主播直播间带货翻车，退款风波持续升温", tag: "商业", heat: "268 万", comments: "3.7 万", delta: "down" },
  { id: 9, title: "校园纪录片《毕业那年的夏天》刷屏，弹幕集体破防", tag: "生活", heat: "219 万", comments: "2.9 万", delta: "up" },
  { id: 10, title: "天文热点「超级瓜月」登场，观星与吃瓜两不误", tag: "奇趣", heat: "186 万", comments: "1.6 万", delta: "new" },
];

export type Feature = {
  id: string;
  cat: string;
  title: string;
  brief: string;
  heat: number;
  comments: string;
  status: string;
  image: string;
};

export const features: Feature[] = [
  {
    id: "f1",
    cat: "影视围观",
    title: "《夜色下的咖啡》：一个结局，全网三派吵到天亮",
    brief: "开放式结局 vs 强收尾？我们把追剧群里的三个主流解读整理成篇，附上线人数与站队比例，看看你的理解属于哪一派。",
    heat: 96,
    comments: "18.4 万",
    status: "持续更新",
    image: "https://readdy.ai/api/search-image?query=cinematic%20evening%20coffee%20shop%20scene%20with%20warm%20lamplight%20and%20city%20glow%20behind%20window%2C%20flat%20editorial%20storybook%20illustration%2C%20cream%20cream%20and%20green%20mint%20palette%20with%20soft%20coral%20accents%2C%20moody%20but%20friendly%2C%20no%20text&width=800&height=560&seq=feat-film&orientation=landscape",
  },
  {
    id: "f2",
    cat: "音乐现场",
    title: "青柠公路转型记：当「清甜」乐队开始玩摇滚",
    brief: "从清新柠檬味到摇滚公路片，成员专访、歌迷反应与乐评人观点一锅端，扒一扒这次大胆转型的台前幕后。",
    heat: 88,
    comments: "12.1 万",
    status: "热度上升",
    image: "https://readdy.ai/api/search-image?query=young%20band%20performing%20on%20stage%20with%20confetti%20and%20light%20beams%2C%20flat%20colorful%20editorial%20illustration%2C%20fresh%20lime%20green%20and%20coral%20red%20palette%2C%20energetic%20concert%20energy%2C%20no%20text&width=800&height=560&seq=feat-music&orientation=landscape",
  },
  {
    id: "f3",
    cat: "游戏一线",
    title: "《山海奇谭》新资料片：玩家连夜排队只为一张图",
    brief: "新地图「沧海归墟」开荒首周数据出炉，氪金与肝党、休闲与硬核玩家在论坛打得火热，我们把战况整理成瓜。",
    heat: 92,
    comments: "9.8 万",
    status: "热议中",
    image: "https://readdy.ai/api/search-image?query=fantasy%20game%20world%20with%20floating%20islands%20and%20mystical%20ocean%20ruins%2C%20vibrant%20flat%20game%20art%20illustration%2C%20teal%20green%20and%20coral%20color%20scheme%2C%20epic%20landscape%2C%20no%20text&width=800&height=560&seq=feat-game&orientation=landscape",
  },
  {
    id: "f4",
    cat: "生活温度",
    title: "阿橘停更 31 天：萌宠圈集体破防的「失踪瓜」",
    brief: "顶流橘猫博主突然停更引发全网寻猫，回归那天评论区泪目刷屏。我们把这场温柔的互联网事件完整记录下来。",
    heat: 84,
    comments: "8.2 万",
    status: "圆满结局",
    image: "https://readdy.ai/api/search-image?query=adorable%20chubby%20orange%20cat%20on%20sunny%20windowsill%20with%20plants%20and%20warm%20sunlight%2C%20flat%20cute%20storybook%20illustration%2C%20cream%20and%20green%20tone%20with%20warm%20amber%20light%2C%20cozy%20and%20heartwarming%2C%20no%20text&width=800&height=560&seq=feat-life&orientation=landscape",
  },
];

export type Channel = { key: string; name: string; icon: string; count: number };

export const channels: Channel[] = [
  { key: "all", name: "全部栏目", icon: "ri-archive-line", count: 16 },
  { key: "yingshi", name: "影视", icon: "ri-clapperboard-line", count: 3 },
  { key: "zongyi", name: "综艺", icon: "ri-tv-line", count: 3 },
  { key: "yinyue", name: "音乐", icon: "ri-music-2-line", count: 2 },
  { key: "youxi", name: "游戏", icon: "ri-gamepad-line", count: 2 },
  { key: "shenghuo", name: "生活", icon: "ri-cup-line", count: 3 },
  { key: "qiqv", name: "奇趣", icon: "ri-sparkling-line", count: 3 },
];

export type Topic = {
  id: string;
  cat: string;
  title: string;
  source: string;
  votes: string;
  heat: number;
  status: "实锤推进" | "热议中" | "等待反转" | "尾声" | "已澄清";
};

export const topicItems: Topic[] = [
  { id: "t01", cat: "yingshi", title: "《夜色下的咖啡》结局导演亲自答疑", source: "导演访谈", votes: "3.2 万", heat: 96, status: "实锤推进" },
  { id: "t02", cat: "yingshi", title: "《候鸟不归》片尾彩蛋藏了三个隐喻", source: "影迷解析", votes: "2.1 万", heat: 74, status: "热议中" },
  { id: "t03", cat: "yingshi", title: "续季选角名单流出，原著党吵翻", source: "多方消息", votes: "1.6 万", heat: 68, status: "等待反转" },
  { id: "t04", cat: "zongyi", title: "回锅季导师阵容与初舞台内幕", source: "节目周边", votes: "2.8 万", heat: 81, status: "实锤推进" },
  { id: "t05", cat: "zongyi", title: "老牌综艺停播传闻时间线复盘", source: "官方回应", votes: "2.4 万", heat: 86, status: "已澄清" },
  { id: "t06", cat: "zongyi", title: "选秀复活赛投票疑云被网友扒出", source: "网友整理", votes: "1.1 万", heat: 59, status: "热议中" },
  { id: "t07", cat: "yinyue", title: "青柠公路新专辑制作团队大换血", source: "成员发声", votes: "3.5 万", heat: 88, status: "实锤推进" },
  { id: "t08", cat: "yinyue", title: "全网翻唱大赛带火一首老歌", source: "社区热帖", votes: "0.9 万", heat: 52, status: "尾声" },
  { id: "t09", cat: "youxi", title: "《山海奇谭》沧海归墟首周爆率调整", source: "官方公告", votes: "2.6 万", heat: 92, status: "实锤推进" },
  { id: "t10", cat: "youxi", title: "电竞杯决赛争议判罚引玩家声讨", source: "赛事回放", votes: "1.9 万", heat: 70, status: "热议中" },
  { id: "t11", cat: "shenghuo", title: "阿橘停更原因首次曝光，看哭全网", source: "博主自述", votes: "3.1 万", heat: 84, status: "尾声" },
  { id: "t12", cat: "shenghuo", title: "毕业生纪录片主角现身弹幕", source: "直播联动", votes: "1.4 万", heat: 63, status: "已澄清" },
  { id: "t13", cat: "shenghuo", title: "网友发起「今晚不做低头族」活动", source: "社区活动", votes: "0.8 万", heat: 47, status: "尾声" },
  { id: "t14", cat: "qiqv", title: "超级瓜月最佳观测点攻略汇总", source: "天文爱好者", votes: "1.2 万", heat: 66, status: "热议中" },
  { id: "t15", cat: "qiqv", title: "城市夜跑新梗「跑瓜」突然刷屏", source: "街采合集", votes: "1.0 万", heat: 58, status: "热议中" },
  { id: "t16", cat: "qiqv", title: "全网都在玩的「口头禅对号入座」挑战", source: "话题挑战", votes: "0.7 万", heat: 44, status: "尾声" },
];

export type Comment = {
  id: number;
  name: string;
  avatar: string;
  stance: string;
  content: string;
  likes: string;
  agree: number;
};

export const comments: Comment[] = [
  { id: 1, name: "阿狸不熬夜", avatar: "AL", stance: "理性吃瓜", content: "先把完整脉络理清楚再站队比较稳，热度高的地方最容易出现断章取义，蹲一个官方说法。", likes: "3.4k", agree: 89 },
  { id: 2, name: "吃着瓜呢", avatar: "CB", stance: "蹲反转", content: "还没到最后时刻，别急着盖棺定论。上个月好几个瓜都是两天内翻转的，我这次学乖了。", likes: "2.1k", agree: 76 },
  { id: 3, name: "城北小李", avatar: "XL", stance: "支持一方", content: "看完完整访谈再说话，把前后文贴出来，这波我站当事人，逻辑说得通。", likes: "1.8k", agree: 71 },
  { id: 4, name: "一颗甜梨", avatar: "TL", stance: "纯看热闹", content: "不吵不站，就是好奇围观群众的数量怎么比事件本身还精彩，吃瓜氛围拉满。", likes: "1.5k", agree: 68 },
  { id: 5, name: "午夜电台", avatar: "DT", stance: "提出质疑", content: "热度这么高但我没看到可靠信源，建议编辑整理时把来源标清楚，别让假瓜满天飞。", likes: "1.2k", agree: 82 },
  { id: 6, name: "瓜田守望者", avatar: "GS", stance: "理性吃瓜", content: "理性看待，多方求证，评论区就事论事。本月目前最扎实的瓜是资料片那波，官方回应很快。", likes: "986", agree: 74 },
];

export type PollOption = { id: string; label: string; ratio: number };

export const pollQuestion = "面对本月这波大瓜，你更倾向哪种吃瓜态度？";

export const pollOptions: PollOption[] = [
  { id: "p1", label: "先理清脉络，再理性发言", ratio: 38 },
  { id: "p2", label: "先站队吃瓜，跟上讨论节奏", ratio: 24 },
  { id: "p3", label: "坐等官方反转，绝不轻易下结论", ratio: 22 },
  { id: "p4", label: "纯看热闹，不发表意见", ratio: 16 },
];

export const moodMeters = [
  { label: "期待反转", value: 34 },
  { label: "保持中立", value: 29 },
  { label: "看好进展", value: 23 },
  { label: "无感路过", value: 14 },
];

export type Faq = { q: string; a: string };

export const faqs: Faq[] = [
  { q: "本月大瓜一般多久更新一次？", a: "本站以「每月」为周期滚动更新重点专题，日常热搜榜与网友热议会持续补进；每期月度盘点会在每月月初上线，方便你一口气围观本月大瓜全貌。" },
  { q: "网站上的大瓜内容都经过核实吗？", a: "我们把内容分成两类：一类是我们团队梳理整理的公开信息专题，会标注来源与进展；另一类是网友评论与吃瓜现场的实时聚合，仅代表发言网友个人观点，标题与卡片都会清楚标注讨论状态。" },
  { q: "我该怎么参与讨论、投稿线索？", a: "你可以在「网友热议」区发表看法，也可以在本页底部的投稿表单里留下昵称、联系方式与线索描述，我们的小编会筛选适合专题化的线索并与你进一步沟通。" },
  { q: "平台上的评论代表官方立场吗？", a: "不代表。评论区、投票与群众反应均来自用户自发表达，仅用于呈现围观氛围与不同声音，本站观点请以「焦点专题」和编辑部署名内容为准。" },
  { q: "可以转载本网站的专题内容吗？", a: "欢迎在注明出处并附上原文链接的前提下，对已标注「可转载」的编辑部专题进行规范转载；聚合类评论内容请在引用时隐去可识别身份的信息。" },
  { q: "遇到不当评论或虚假线索怎么办？", a: "你可以通过投稿表单选择「投诉 / 举报」并填写链接说明，我们会核查后处理，同时配合平台规则维护评论区秩序。" },
];

export const aboutStats = [
  { value: "12", label: "累计专题期数" },
  { value: "38w+", label: "累计围观人次" },
  { value: "96%", label: "专题内容可追溯率" },
  { value: "24h", label: "举报处理时效" },
];